import { config } from './config.helpers'

const createIdentityAppLoginUrl = (
  slug?: string | null,
  profileId?: string | null
) => {
  const url = new URL('/auth/login', config.identityAppBaseUrl)
  url.searchParams.set('app', 'creator')
  url.searchParams.set('returnUrl', window.location.href)

  return url.toString()
}

const createIdentityAppRegisterUrl = (
  slug?: string | null,
  profileId?: string | null
) => {
  const url = new URL('/auth/registration', config.identityAppBaseUrl)
  url.searchParams.set('app', 'creator')
  url.searchParams.set('returnUrl', window.location.href)

  if (slug) {
    url.searchParams.set('slug', slug)
  }
  if (profileId) {
    url.searchParams.set('profile', profileId)
  }
  return url.toString()
}

const createIdentityAppResetPasswordUrl = () => {
  const url = new URL('/auth/recovery', config.identityAppBaseUrl)
  url.searchParams.set('app', 'creator')
  url.searchParams.set('returnUrl', window.origin)

  return url.toString()
}

const createIdentityAppSettingsUrl = () => {
  const url = new URL('/auth/settings', config.identityAppBaseUrl)
  url.searchParams.set('app', 'creator')

  return url.toString()
}

export const getIdentityAppUrl = (
  type: 'login' | 'registration' | 'recovery' | 'settings',
  params?: Record<string, string>
) => {
  const slug = params?.slug
  const profileId = params?.profileId

  switch (type) {
    case 'login':
      return createIdentityAppLoginUrl(slug, profileId)
    case 'registration':
      return createIdentityAppRegisterUrl(slug, profileId)
    case 'recovery':
      return createIdentityAppResetPasswordUrl()
    case 'settings':
      return createIdentityAppSettingsUrl()
    default:
      return config.identityAppBaseUrl
  }
}
